<template>
  <div class="logo-design-page">
    <!-- Hero Section -->
    <section class="logo-hero">
      <div class="container">
        <h1 class="logo-hero-title">FULFILLDROP Logo Design</h1>
        <p class="logo-hero-desc">专业物流品牌标识设计 - 体现信任、效率与全球化</p>
      </div>
    </section>

    <!-- Design Principles -->
    <section class="principles-section">
      <div class="container">
        <h2 class="section-title">顶级 Logo 设计原则</h2>
        <div class="principles-grid">
          <div class="principle-card" data-aos="fade-up">
            <div class="principle-icon">
              <i class="fa-solid fa-bullseye"></i>
            </div>
            <h3>简洁性</h3>
            <p>易于识别和记忆，去除多余元素</p>
          </div>
          <div class="principle-card" data-aos="fade-up" data-aos-delay="100">
            <div class="principle-icon">
              <i class="fa-solid fa-clock"></i>
            </div>
            <h3>持久性</h3>
            <p>超越时尚潮流，长期有效</p>
          </div>
          <div class="principle-card" data-aos="fade-up" data-aos-delay="200">
            <div class="principle-icon">
              <i class="fa-solid fa-layer-group"></i>
            </div>
            <h3>适应性</h3>
            <p>跨平台、跨尺寸保持一致性</p>
          </div>
          <div class="principle-card" data-aos="fade-up" data-aos-delay="300">
            <div class="principle-icon">
              <i class="fa-solid fa-lightbulb"></i>
            </div>
            <h3>相关性</h3>
            <p>符合行业特性和品牌定位</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Logo Options -->
    <section class="logo-options-section">
      <div class="container">
        <h2 class="section-title">设计方案展示</h2>
        
        <!-- Option 1: Integrated Monogram -->
        <div class="logo-option" data-aos="fade-up">
          <div class="logo-option-header">
            <h3>方案一：字母组合体</h3>
            <p>F字母与物流元素融合 - 形成统一的视觉标识</p>
          </div>
          <div class="logo-display">
            <div class="logo-preview logo-preview--1">
              <svg viewBox="0 0 400 120" class="logo-svg">
                <defs>
                  <linearGradient id="LogoGrad1" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stop-color="#28b5c1" />
                    <stop offset="100%" stop-color="#1e9aa5" />
                  </linearGradient>
                </defs>
                <!-- Integrated F + Box Icon -->
                <path d="M25 25 L25 85 M25 25 L55 25 L55 45 L35 45 L35 55 L50 55 L50 65 L35 65 L35 85" fill="none" stroke="url(#LogoGrad1)" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"/>
                <!-- Arrow connecting to text -->
                <path d="M75 55 L85 55" stroke="url(#LogoGrad1)" stroke-width="3" stroke-linecap="round"/>
                <!-- Text integrated with icon -->
                <text x="95" y="62" fill="#1e293b" font-family="Inter, -apple-system, Arial, sans-serif" font-size="32" font-weight="800" letter-spacing="-0.01em">ULFILLDROP</text>
              </svg>
            </div>
            <div class="logo-variants">
              <div class="variant-card">
                <span class="variant-label">深色背景</span>
                <div class="variant-preview variant-preview--dark">
                  <svg viewBox="0 0 200 60" class="logo-svg-sm">
                    <path d="M10 15 L10 45 M10 15 L27 15 L27 25 L18 25 L18 30 L25 30 L25 35 L18 35 L18 45" fill="none" stroke="#fff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                    <text x="38" y="32" fill="#fff" font-family="Inter, sans-serif" font-size="16" font-weight="800">ULFILLDROP</text>
                  </svg>
                </div>
              </div>
              <div class="variant-card">
                <span class="variant-label">图标版本</span>
                <div class="variant-preview variant-preview--icon">
                  <svg viewBox="0 0 60 60" class="logo-svg-icon">
                    <path d="M15 15 L15 45 M15 15 L35 15 L35 25 L22 25 L22 32 L32 32 L32 38 L22 38 L22 45" fill="none" stroke="url(#LogoGrad1)" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Option 2: Unified Flow -->
        <div class="logo-option" data-aos="fade-up">
          <div class="logo-option-header">
            <h3>方案二：流动融合体</h3>
            <p>字母F与流动轨迹融合 - 形成统一的视觉符号</p>
          </div>
          <div class="logo-display">
            <div class="logo-preview logo-preview--2">
              <svg viewBox="0 0 400 120" class="logo-svg">
                <defs>
                  <linearGradient id="LogoGrad2" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stop-color="#3b82f6" />
                    <stop offset="50%" stop-color="#4ec8d4" />
                    <stop offset="100%" stop-color="#ec4899" />
                  </linearGradient>
                </defs>
                <!-- Integrated F + Flow -->
                <path d="M25 85 L25 25 Q45 25 65 45 Q85 65 85 85" fill="none" stroke="url(#LogoGrad2)" stroke-width="8" stroke-linecap="round"/>
                <circle cx="85" cy="85" r="8" fill="url(#LogoGrad2)"/>
                <!-- Text starts after the flow -->
                <text x="105" y="62" fill="#1e293b" font-family="Inter, sans-serif" font-size="32" font-weight="700" letter-spacing="-0.01em">ULFILLDROP</text>
              </svg>
            </div>
            <div class="logo-variants">
              <div class="variant-card">
                <span class="variant-label">深色背景</span>
                <div class="variant-preview variant-preview--dark">
                  <svg viewBox="0 0 200 60" class="logo-svg-sm">
                    <path d="M10 45 L10 15 Q20 15 30 27 Q40 39 40 45" fill="none" stroke="#fff" stroke-width="4" stroke-linecap="round"/>
                    <circle cx="40" cy="45" r="4" fill="#fff"/>
                    <text x="52" y="32" fill="#fff" font-family="Inter, sans-serif" font-size="16" font-weight="700">ULFILLDROP</text>
                  </svg>
                </div>
              </div>
              <div class="variant-card">
                <span class="variant-label">图标版本</span>
                <div class="variant-preview variant-preview--icon">
                  <svg viewBox="0 0 60 60" class="logo-svg-icon">
                    <path d="M15 50 L15 15 Q25 15 35 27 Q45 39 45 50" fill="none" stroke="url(#LogoGrad2)" stroke-width="5" stroke-linecap="round"/>
                    <circle cx="45" cy="50" r="5" fill="url(#LogoGrad2)"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Option 3: Global Connect -->
        <div class="logo-option" data-aos="fade-up">
          <div class="logo-option-header">
            <h3>方案三：全球连接体</h3>
            <p>字母F与地球网格融合 - 象征全球物流网络</p>
          </div>
          <div class="logo-display">
            <div class="logo-preview logo-preview--3">
              <svg viewBox="0 0 400 120" class="logo-svg">
                <defs>
                  <linearGradient id="LogoGrad3" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stop-color="#0ea5e9" />
                    <stop offset="100%" stop-color="#3ec4cf" />
                  </linearGradient>
                </defs>
                <!-- Integrated F + Globe -->
                <circle cx="40" cy="55" r="30" fill="none" stroke="url(#LogoGrad3)" stroke-width="3"/>
                <path d="M40 25 L40 85 M10 55 L70 55" fill="none" stroke="url(#LogoGrad3)" stroke-width="2" opacity="0.5"/>
                <path d="M20 35 Q40 55 60 35 M20 75 Q40 55 60 75" fill="none" stroke="url(#LogoGrad3)" stroke-width="2" opacity="0.5"/>
                <!-- F shape inside globe -->
                <path d="M22 55 L22 85 L50 85 L50 55" fill="none" stroke="url(#LogoGrad3)" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
                <!-- Connection point -->
                <circle cx="70" cy="55" r="5" fill="url(#LogoGrad3)"/>
                <!-- Text integrated -->
                <text x="85" y="62" fill="#1e293b" font-family="Inter, sans-serif" font-size="32" font-weight="700">ULFILLDROP</text>
              </svg>
            </div>
            <div class="logo-variants">
              <div class="variant-card">
                <span class="variant-label">深色背景</span>
                <div class="variant-preview variant-preview--dark">
                  <svg viewBox="0 0 200 60" class="logo-svg-sm">
                    <circle cx="25" cy="30" r="18" fill="none" stroke="#fff" stroke-width="2"/>
                    <path d="M14 30 L14 48 L38 48 L38 30" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                    <circle cx="44" cy="30" r="3" fill="#fff"/>
                    <text x="52" y="32" fill="#fff" font-family="Inter, sans-serif" font-size="16" font-weight="700">ULFILLDROP</text>
                  </svg>
                </div>
              </div>
              <div class="variant-card">
                <span class="variant-label">图标版本</span>
                <div class="variant-preview variant-preview--icon">
                  <svg viewBox="0 0 60 60" class="logo-svg-icon">
                    <circle cx="30" cy="30" r="22" fill="none" stroke="url(#LogoGrad3)" stroke-width="3"/>
                    <path d="M18 30 L18 48 L42 48 L42 30" fill="none" stroke="url(#LogoGrad3)" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                    <circle cx="46" cy="30" r="4" fill="url(#LogoGrad3)"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Option 4: Package Integrate -->
        <div class="logo-option" data-aos="fade-up">
          <div class="logo-option-header">
            <h3>方案四：包裹融合体</h3>
            <p>字母F与包裹箱融合 - 传递物流配送核心价值</p>
          </div>
          <div class="logo-display">
            <div class="logo-preview logo-preview--4">
              <svg viewBox="0 0 400 120" class="logo-svg">
                <defs>
                  <linearGradient id="LogoGrad4" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stop-color="#10b981" />
                    <stop offset="100%" stop-color="#059669" />
                  </linearGradient>
                </defs>
                <!-- Integrated F + Package -->
                <path d="M20 85 L20 30 L60 30 L60 45 L35 45 L35 55 L55 55 L55 65 L35 65 L35 85" fill="none" stroke="url(#LogoGrad4)" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
                <!-- Arrow point -->
                <path d="M70 55 L80 55 M75 50 L80 55 L75 60" fill="none" stroke="url(#LogoGrad4)" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                <!-- Text integrated -->
                <text x="90" y="62" fill="#1e293b" font-family="Inter, sans-serif" font-size="32" font-weight="700">ULFILLDROP</text>
              </svg>
            </div>
            <div class="logo-variants">
              <div class="variant-card">
                <span class="variant-label">深色背景</span>
                <div class="variant-preview variant-preview--dark">
                  <svg viewBox="0 0 200 60" class="logo-svg-sm">
                    <path d="M8 45 L8 18 L30 18 L30 27 L17 27 L17 33 L28 33 L28 39 L17 39 L17 45" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M35 30 L40 30 M37 27 L40 30 L37 33" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <text x="45" y="32" fill="#fff" font-family="Inter, sans-serif" font-size="16" font-weight="700">ULFILLDROP</text>
                  </svg>
                </div>
              </div>
              <div class="variant-card">
                <span class="variant-label">图标版本</span>
                <div class="variant-preview variant-preview--icon">
                  <svg viewBox="0 0 60 60" class="logo-svg-icon">
                    <path d="M12 50 L12 15 L35 15 L35 25 L20 25 L20 32 L32 32 L32 39 L20 39 L20 50" fill="none" stroke="url(#LogoGrad4)" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Option 5: Stripe Style - Bold Monogram -->
        <div class="logo-option" data-aos="fade-up">
          <div class="logo-option-header">
            <h3>方案五：粗体字母标</h3>
            <p>参考Stripe风格 - 粗体几何字母，现代感强烈</p>
          </div>
          <div class="logo-display">
            <div class="logo-preview logo-preview--5">
              <svg viewBox="0 0 400 120" class="logo-svg">
                <defs>
                  <linearGradient id="LogoGrad5" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stop-color="#000000" />
                    <stop offset="100%" stop-color="#374151" />
                  </linearGradient>
                </defs>
                <!-- Bold F Monogram -->
                <rect x="15" y="20" width="50" height="80" rx="6" fill="url(#LogoGrad5)"/>
                <rect x="25" y="30" width="30" height="60" rx="3" fill="#fff"/>
                <rect x="25" y="30" width="30" height="15" fill="url(#LogoGrad5)"/>
                <rect x="25" y="55" width="30" height="15" fill="url(#LogoGrad5)"/>
                <!-- Text -->
                <text x="75" y="62" fill="#1e293b" font-family="Inter, sans-serif" font-size="32" font-weight="900" letter-spacing="0.02em">ULFILLDROP</text>
              </svg>
            </div>
            <div class="logo-variants">
              <div class="variant-card">
                <span class="variant-label">浅色版本</span>
                <div class="variant-preview variant-preview--mono">
                  <svg viewBox="0 0 200 60" class="logo-svg-sm">
                    <rect x="8" y="10" width="25" height="40" rx="4" fill="#f1f5f9"/>
                    <rect x="13" y="15" width="15" height="30" rx="2" fill="#1e293b"/>
                    <rect x="13" y="15" width="15" height="8" fill="#f1f5f9"/>
                    <text x="40" y="32" fill="#1e293b" font-family="Inter, sans-serif" font-size="16" font-weight="900">ULFILLDROP</text>
                  </svg>
                </div>
              </div>
              <div class="variant-card">
                <span class="variant-label">图标版本</span>
                <div class="variant-preview variant-preview--icon">
                  <svg viewBox="0 0 60 60" class="logo-svg-icon">
                    <rect x="8" y="8" width="44" height="44" rx="8" fill="#1e293b"/>
                    <rect x="15" y="15" width="28" height="30" rx="4" fill="#fff"/>
                    <rect x="15" y="15" width="28" height="8" fill="#1e293b"/>
                    <rect x="15" y="32" width="28" height="8" fill="#1e293b"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Option 6: Airbnb Style - Warm Gradient -->
        <div class="logo-option" data-aos="fade-up">
          <div class="logo-option-header">
            <h3>方案六：温暖渐变</h3>
            <p>参考Airbnb风格 - 温暖的橙红渐变，亲和力强</p>
          </div>
          <div class="logo-display">
            <div class="logo-preview logo-preview--6">
              <svg viewBox="0 0 400 120" class="logo-svg">
                <defs>
                  <linearGradient id="LogoGrad6" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stop-color="#ff5a5f" />
                    <stop offset="50%" stop-color="#ff7e5f" />
                    <stop offset="100%" stop-color="#feb47b" />
                  </linearGradient>
                </defs>
                <!-- F + Drop Shape -->
                <path d="M20 30 L20 90 L60 90 L60 50 L40 50 L40 40 L60 40 L60 30 Z" fill="url(#LogoGrad6)" rx="8"/>
                <circle cx="60" cy="65" r="8" fill="#fff"/>
                <!-- Text -->
                <text x="85" y="62" fill="#1e293b" font-family="Inter, sans-serif" font-size="32" font-weight="700" letter-spacing="-0.01em">ULFILLDROP</text>
              </svg>
            </div>
            <div class="logo-variants">
              <div class="variant-card">
                <span class="variant-label">深色背景</span>
                <div class="variant-preview variant-preview--dark">
                  <svg viewBox="0 0 200 60" class="logo-svg-sm">
                    <path d="M5 15 L5 45 L25 45 L25 30 L15 30 L15 25 L25 25 L25 15 Z" fill="url(#LogoGrad6)" rx="4"/>
                    <circle cx="25" cy="32" r="4" fill="#fff"/>
                    <text x="35" y="32" fill="#fff" font-family="Inter, sans-serif" font-size="16" font-weight="700">ULFILLDROP</text>
                  </svg>
                </div>
              </div>
              <div class="variant-card">
                <span class="variant-label">图标版本</span>
                <div class="variant-preview variant-preview--icon">
                  <svg viewBox="0 0 60 60" class="logo-svg-icon">
                    <path d="M10 12 L10 48 L38 48 L38 32 L26 32 L26 26 L38 26 L38 12 Z" fill="url(#LogoGrad6)" rx="6"/>
                    <circle cx="38" cy="40" r="5" fill="#fff"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Option 7: Figma Style - Playful Geometric -->
        <div class="logo-option" data-aos="fade-up">
          <div class="logo-option-header">
            <h3>方案七：趣味几何</h3>
            <p>参考Figma风格 - 活泼的几何图形组合，现代感十足</p>
          </div>
          <div class="logo-display">
            <div class="logo-preview logo-preview--7">
              <svg viewBox="0 0 400 120" class="logo-svg">
                <defs>
                  <linearGradient id="LogoGrad7a" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stop-color="#f24e1e" />
                    <stop offset="100%" stop-color="#ff7262" />
                  </linearGradient>
                  <linearGradient id="LogoGrad7b" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stop-color="#a259ff" />
                    <stop offset="100%" stop-color="#3ec4cf" />
                  </linearGradient>
                </defs>
                <!-- Geometric F -->
                <rect x="15" y="20" width="18" height="80" rx="4" fill="url(#LogoGrad7a)"/>
                <rect x="33" y="20" width="32" height="22" rx="4" fill="url(#LogoGrad7b)"/>
                <rect x="33" y="54" width="22" height="22" rx="4" fill="url(#LogoGrad7a)"/>
                <rect x="55" y="54" width="10" height="22" rx="4" fill="#1e293b"/>
                <!-- Text -->
                <text x="80" y="62" fill="#1e293b" font-family="Inter, sans-serif" font-size="32" font-weight="700" letter-spacing="-0.01em">ULFILLDROP</text>
              </svg>
            </div>
            <div class="logo-variants">
              <div class="variant-card">
                <span class="variant-label">深色背景</span>
                <div class="variant-preview variant-preview--dark">
                  <svg viewBox="0 0 200 60" class="logo-svg-sm">
                    <rect x="5" y="10" width="10" height="40" rx="2" fill="#ff7262"/>
                    <rect x="15" y="10" width="18" height="12" rx="2" fill="#3ec4cf"/>
                    <rect x="15" y="28" width="12" height="12" rx="2" fill="#ff7262"/>
                    <rect x="27" y="28" width="6" height="12" rx="2" fill="#fff"/>
                    <text x="40" y="32" fill="#fff" font-family="Inter, sans-serif" font-size="16" font-weight="700">ULFILLDROP</text>
                  </svg>
                </div>
              </div>
              <div class="variant-card">
                <span class="variant-label">图标版本</span>
                <div class="variant-preview variant-preview--icon">
                  <svg viewBox="0 0 60 60" class="logo-svg-icon">
                    <rect x="8" y="8" width="12" height="44" rx="3" fill="url(#LogoGrad7a)"/>
                    <rect x="20" y="8" width="20" height="14" rx="3" fill="url(#LogoGrad7b)"/>
                    <rect x="20" y="28" width="14" height="14" rx="3" fill="url(#LogoGrad7a)"/>
                    <rect x="34" y="28" width="6" height="14" rx="3" fill="#1e293b"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Option 8: TikTok Style - Bold Contrast -->
        <div class="logo-option" data-aos="fade-up">
          <div class="logo-option-header">
            <h3>方案八：大胆对比</h3>
            <p>参考TikTok风格 - 大胆的色彩对比，年轻化设计</p>
          </div>
          <div class="logo-display">
            <div class="logo-preview logo-preview--8">
              <svg viewBox="0 0 400 120" class="logo-svg">
                <defs>
                  <linearGradient id="LogoGrad8" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stop-color="#000000" />
                    <stop offset="100%" stop-color="#1f2937" />
                  </linearGradient>
                </defs>
                <!-- Bold F on Circle -->
                <circle cx="40" cy="55" r="35" fill="url(#LogoGrad8)"/>
                <path d="M20 55 L20 85 L55 85 L55 55" fill="#fff"/>
                <path d="M20 55 L20 30 L55 30" fill="#ff0040"/>
                <!-- Text -->
                <text x="85" y="62" fill="#1e293b" font-family="Inter, sans-serif" font-size="32" font-weight="800" letter-spacing="0.01em">ULFILLDROP</text>
              </svg>
            </div>
            <div class="logo-variants">
              <div class="variant-card">
                <span class="variant-label">浅色版本</span>
                <div class="variant-preview variant-preview--mono">
                  <svg viewBox="0 0 200 60" class="logo-svg-sm">
                    <circle cx="22" cy="30" r="18" fill="#f1f5f9" stroke="#1e293b" stroke-width="2"/>
                    <path d="M12 30 L12 48 L32 48 L32 30" fill="#1e293b"/>
                    <path d="M12 30 L12 18 L32 18" fill="#ef4444"/>
                    <text x="45" y="32" fill="#1e293b" font-family="Inter, sans-serif" font-size="16" font-weight="800">ULFILLDROP</text>
                  </svg>
                </div>
              </div>
              <div class="variant-card">
                <span class="variant-label">图标版本</span>
                <div class="variant-preview variant-preview--icon">
                  <svg viewBox="0 0 60 60" class="logo-svg-icon">
                    <circle cx="30" cy="30" r="25" fill="#1e293b"/>
                    <path d="M18 30 L18 48 L42 48 L42 30" fill="#fff"/>
                    <path d="M18 30 L18 18 L42 18" fill="#ff0040"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Option 9: Google Style - Minimalist -->
        <div class="logo-option" data-aos="fade-up">
          <div class="logo-option-header">
            <h3>方案九：谷歌简约</h3>
            <p>参考Google风格 - 简约多彩，亲和力强</p>
          </div>
          <div class="logo-display">
            <div class="logo-preview logo-preview--9">
              <svg viewBox="0 0 400 120" class="logo-svg">
                <!-- Colorful F -->
                <rect x="15" y="20" width="14" height="80" fill="#4285F4"/>
                <rect x="29" y="20" width="36" height="20" fill="#EA4335"/>
                <rect x="29" y="40" width="36" height="20" fill="#FBBC05"/>
                <rect x="29" y="60" width="22" height="40" fill="#34A853"/>
                <rect x="51" y="60" width="14" height="40" fill="#EA4335"/>
                <!-- Text -->
                <text x="75" y="62" fill="#1e293b" font-family="Inter, sans-serif" font-size="32" font-weight="700" letter-spacing="-0.01em">ULFILLDROP</text>
              </svg>
            </div>
            <div class="logo-variants">
              <div class="variant-card">
                <span class="variant-label">深色背景</span>
                <div class="variant-preview variant-preview--dark">
                  <svg viewBox="0 0 200 60" class="logo-svg-sm">
                    <rect x="5" y="10" width="8" height="40" fill="#4285F4"/>
                    <rect x="13" y="10" width="20" height="12" fill="#EA4335"/>
                    <rect x="13" y="22" width="20" height="12" fill="#FBBC05"/>
                    <rect x="13" y="34" width="12" height="16" fill="#34A853"/>
                    <rect x="25" y="34" width="8" height="16" fill="#EA4335"/>
                    <text x="38" y="32" fill="#fff" font-family="Inter, sans-serif" font-size="16" font-weight="700">ULFILLDROP</text>
                  </svg>
                </div>
              </div>
              <div class="variant-card">
                <span class="variant-label">图标版本</span>
                <div class="variant-preview variant-preview--icon">
                  <svg viewBox="0 0 60 60" class="logo-svg-icon">
                    <rect x="8" y="8" width="10" height="44" fill="#4285F4"/>
                    <rect x="18" y="8" width="24" height="14" fill="#EA4335"/>
                    <rect x="18" y="22" width="24" height="14" fill="#FBBC05"/>
                    <rect x="18" y="36" width="14" height="16" fill="#34A853"/>
                    <rect x="32" y="36" width="10" height="16" fill="#EA4335"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Option 10: Meta Style - Gradient -->
        <div class="logo-option" data-aos="fade-up">
          <div class="logo-option-header">
            <h3>方案十：Meta渐变</h3>
            <p>参考Meta风格 - 深邃蓝紫渐变，科技感强</p>
          </div>
          <div class="logo-display">
            <div class="logo-preview logo-preview--10">
              <svg viewBox="0 0 400 120" class="logo-svg">
                <defs>
                  <linearGradient id="LogoGrad10" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stop-color="#1877F2" />
                    <stop offset="50%" stop-color="#4267B2" />
                    <stop offset="100%" stop-color="#833AB4" />
                  </linearGradient>
                </defs>
                <!-- F on gradient -->
                <rect x="15" y="20" width="50" height="80" rx="8" fill="url(#LogoGrad10)"/>
                <rect x="25" y="35" width="30" height="50" rx="4" fill="rgba(255,255,255,0.15)"/>
                <rect x="25" y="35" width="30" height="12" fill="#fff"/>
                <rect x="25" y="55" width="30" height="12" fill="#fff"/>
                <!-- Text -->
                <text x="75" y="62" fill="#1e293b" font-family="Inter, sans-serif" font-size="32" font-weight="700" letter-spacing="-0.01em">ULFILLDROP</text>
              </svg>
            </div>
            <div class="logo-variants">
              <div class="variant-card">
                <span class="variant-label">深色背景</span>
                <div class="variant-preview variant-preview--dark">
                  <svg viewBox="0 0 200 60" class="logo-svg-sm">
                    <rect x="5" y="10" width="25" height="40" rx="4" fill="url(#LogoGrad10)"/>
                    <rect x="10" y="17" width="15" height="26" rx="2" fill="rgba(255,255,255,0.15)"/>
                    <rect x="10" y="17" width="15" height="6" fill="#fff"/>
                    <rect x="10" y="29" width="15" height="6" fill="#fff"/>
                    <text x="35" y="32" fill="#fff" font-family="Inter, sans-serif" font-size="16" font-weight="700">ULFILLDROP</text>
                  </svg>
                </div>
              </div>
              <div class="variant-card">
                <span class="variant-label">图标版本</span>
                <div class="variant-preview variant-preview--icon">
                  <svg viewBox="0 0 60 60" class="logo-svg-icon">
                    <rect x="8" y="8" width="44" height="44" rx="8" fill="url(#LogoGrad10)"/>
                    <rect x="16" y="16" width="28" height="28" rx="4" fill="rgba(255,255,255,0.15)"/>
                    <rect x="16" y="16" width="28" height="8" fill="#fff"/>
                    <rect x="16" y="30" width="28" height="8" fill="#fff"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Option 11: Netflix Style - Bold Red -->
        <div class="logo-option" data-aos="fade-up">
          <div class="logo-option-header">
            <h3>方案十一：Netflix红</h3>
            <p>参考Netflix风格 - 大胆红色，视觉冲击力强</p>
          </div>
          <div class="logo-display">
            <div class="logo-preview logo-preview--11">
              <svg viewBox="0 0 400 120" class="logo-svg">
                <!-- Bold Red F -->
                <path d="M15 20 L15 100 L70 100 L70 70 L40 70 L40 55 L70 55 L70 30 L40 30 L40 20 Z" fill="#E50914"/>
                <!-- Text -->
                <text x="85" y="62" fill="#1e293b" font-family="Inter, sans-serif" font-size="32" font-weight="900" letter-spacing="0.02em">ULFILLDROP</text>
              </svg>
            </div>
            <div class="logo-variants">
              <div class="variant-card">
                <span class="variant-label">深色背景</span>
                <div class="variant-preview variant-preview--dark">
                  <svg viewBox="0 0 200 60" class="logo-svg-sm">
                    <path d="M5 10 L5 50 L38 50 L38 38 L22 38 L22 32 L38 32 L38 18 L22 18 L22 10 Z" fill="#E50914"/>
                    <text x="48" y="32" fill="#fff" font-family="Inter, sans-serif" font-size="16" font-weight="900">ULFILLDROP</text>
                  </svg>
                </div>
              </div>
              <div class="variant-card">
                <span class="variant-label">图标版本</span>
                <div class="variant-preview variant-preview--icon">
                  <svg viewBox="0 0 60 60" class="logo-svg-icon">
                    <path d="M8 8 L8 52 L42 52 L42 38 L26 38 L26 30 L42 30 L42 14 L26 14 L26 8 Z" fill="#E50914"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Option 12: Spotify Style - Fresh Green -->
        <div class="logo-option" data-aos="fade-up">
          <div class="logo-option-header">
            <h3>方案十二：Spotify绿</h3>
            <p>参考Spotify风格 - 清新绿色，充满活力</p>
          </div>
          <div class="logo-display">
            <div class="logo-preview logo-preview--12">
              <svg viewBox="0 0 400 120" class="logo-svg">
                <defs>
                  <linearGradient id="LogoGrad12" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stop-color="#1DB954" />
                    <stop offset="100%" stop-color="#1ED760" />
                  </linearGradient>
                </defs>
                <!-- F with rounded corners -->
                <rect x="15" y="20" width="14" height="80" rx="7" fill="url(#LogoGrad12)"/>
                <rect x="29" y="20" width="36" height="20" rx="10" fill="url(#LogoGrad12)"/>
                <rect x="29" y="45" width="36" height="20" rx="10" fill="url(#LogoGrad12)"/>
                <rect x="29" y="75" width="36" height="25" rx="10" fill="url(#LogoGrad12)"/>
                <!-- Text -->
                <text x="75" y="62" fill="#1e293b" font-family="Inter, sans-serif" font-size="32" font-weight="700" letter-spacing="-0.01em">ULFILLDROP</text>
              </svg>
            </div>
            <div class="logo-variants">
              <div class="variant-card">
                <span class="variant-label">深色背景</span>
                <div class="variant-preview variant-preview--dark">
                  <svg viewBox="0 0 200 60" class="logo-svg-sm">
                    <rect x="5" y="10" width="8" height="40" rx="4" fill="url(#LogoGrad12)"/>
                    <rect x="13" y="10" width="20" height="12" rx="6" fill="url(#LogoGrad12)"/>
                    <rect x="13" y="27" width="20" height="12" rx="6" fill="url(#LogoGrad12)"/>
                    <rect x="13" y="44" width="20" height="16" rx="6" fill="url(#LogoGrad12)"/>
                    <text x="38" y="32" fill="#fff" font-family="Inter, sans-serif" font-size="16" font-weight="700">ULFILLDROP</text>
                  </svg>
                </div>
              </div>
              <div class="variant-card">
                <span class="variant-label">图标版本</span>
                <div class="variant-preview variant-preview--icon">
                  <svg viewBox="0 0 60 60" class="logo-svg-icon">
                    <circle cx="30" cy="30" r="26" fill="url(#LogoGrad12)"/>
                    <rect x="16" y="16" width="8" height="28" rx="4" fill="#1e293b"/>
                    <rect x="26" y="16" width="18" height="10" rx="5" fill="#1e293b"/>
                    <rect x="26" y="32" width="18" height="10" rx="5" fill="#1e293b"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Option 13: Amazon Style - Arrow -->
        <div class="logo-option" data-aos="fade-up">
          <div class="logo-option-header">
            <h3>方案十三：Amazon箭头</h3>
            <p>参考Amazon风格 - 箭头连接，寓意向前</p>
          </div>
          <div class="logo-display">
            <div class="logo-preview logo-preview--13">
              <svg viewBox="0 0 400 120" class="logo-svg">
                <!-- F + Arrow -->
                <rect x="15" y="20" width="50" height="80" rx="4" fill="#FF9900"/>
                <rect x="25" y="30" width="30" height="60" rx="2" fill="#fff"/>
                <rect x="25" y="30" width="30" height="15" fill="#FF9900"/>
                <!-- Arrow connecting to text -->
                <path d="M70 50 L90 50 L85 60 L95 60 L80 75 L65 60 L75 60 Z" fill="#FF9900"/>
                <!-- Text -->
                <text x="95" y="62" fill="#1e293b" font-family="Inter, sans-serif" font-size="32" font-weight="700" letter-spacing="-0.01em">ULFILLDROP</text>
              </svg>
            </div>
            <div class="logo-variants">
              <div class="variant-card">
                <span class="variant-label">深色背景</span>
                <div class="variant-preview variant-preview--dark">
                  <svg viewBox="0 0 200 60" class="logo-svg-sm">
                    <rect x="5" y="10" width="25" height="40" rx="2" fill="#FF9900"/>
                    <rect x="10" y="15" width="15" height="30" rx="1" fill="#1e293b"/>
                    <rect x="10" y="15" width="15" height="8" fill="#FF9900"/>
                    <path d="M35 28 L45 28 L42 34 L48 34 L38 45 L28 34 L38 34 Z" fill="#FF9900"/>
                    <text x="52" y="32" fill="#fff" font-family="Inter, sans-serif" font-size="16" font-weight="700">ULFILLDROP</text>
                  </svg>
                </div>
              </div>
              <div class="variant-card">
                <span class="variant-label">图标版本</span>
                <div class="variant-preview variant-preview--icon">
                  <svg viewBox="0 0 60 60" class="logo-svg-icon">
                    <rect x="10" y="10" width="40" height="40" rx="4" fill="#FF9900"/>
                    <rect x="18" y="18" width="24" height="24" rx="2" fill="#fff"/>
                    <rect x="18" y="18" width="24" height="8" fill="#FF9900"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Option 14: Slack Style - Playful -->
        <div class="logo-option" data-aos="fade-up">
          <div class="logo-option-header">
            <h3>方案十四：Slack活泼</h3>
            <p>参考Slack风格 - 活泼配色，友好亲切</p>
          </div>
          <div class="logo-display">
            <div class="logo-preview logo-preview--14">
              <svg viewBox="0 0 400 120" class="logo-svg">
                <!-- Playful F -->
                <circle cx="30" cy="55" r="35" fill="#E01E5A"/>
                <rect x="20" y="30" width="8" height="50" rx="4" fill="#fff"/>
                <rect x="28" y="30" width="20" height="12" rx="6" fill="#fff"/>
                <rect x="28" y="50" width="14" height="12" rx="6" fill="#fff"/>
                <rect x="42" y="50" width="6" height="12" rx="3" fill="#E01E5A"/>
                <!-- Text -->
                <text x="75" y="62" fill="#1e293b" font-family="Inter, sans-serif" font-size="32" font-weight="700" letter-spacing="-0.01em">ULFILLDROP</text>
              </svg>
            </div>
            <div class="logo-variants">
              <div class="variant-card">
                <span class="variant-label">浅色版本</span>
                <div class="variant-preview variant-preview--mono">
                  <svg viewBox="0 0 200 60" class="logo-svg-sm">
                    <circle cx="20" cy="30" r="18" fill="#E01E5A"/>
                    <rect x="15" y="18" width="5" height="24" rx="2" fill="#fff"/>
                    <rect x="20" y="18" width="10" height="6" rx="3" fill="#fff"/>
                    <rect x="20" y="28" width="7" height="6" rx="3" fill="#fff"/>
                    <text x="43" y="32" fill="#1e293b" font-family="Inter, sans-serif" font-size="16" font-weight="700">ULFILLDROP</text>
                  </svg>
                </div>
              </div>
              <div class="variant-card">
                <span class="variant-label">图标版本</span>
                <div class="variant-preview variant-preview--icon">
                  <svg viewBox="0 0 60 60" class="logo-svg-icon">
                    <circle cx="30" cy="30" r="26" fill="#E01E5A"/>
                    <rect x="22" y="18" width="6" height="24" rx="3" fill="#fff"/>
                    <rect x="28" y="18" width="12" height="8" rx="4" fill="#fff"/>
                    <rect x="28" y="32" width="8" height="8" rx="4" fill="#fff"/>
                    <rect x="36" y="32" width="4" height="8" rx="2" fill="#E01E5A"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>

    <!-- Color Palette -->
    <section class="color-palette-section">
      <div class="container">
        <h2 class="section-title">品牌色彩系统</h2>
        <div class="color-grid">
          <div class="color-card" data-aos="zoom-in">
            <div class="color-swatch" style="background: #28b5c1;"></div>
            <div class="color-info">
              <h4>Primary Blue</h4>
              <p>#4F46E5</p>
              <span>信任、专业、科技</span>
            </div>
          </div>
          <div class="color-card" data-aos="zoom-in" data-aos-delay="100">
            <div class="color-swatch" style="background: #1e9aa5;"></div>
            <div class="color-info">
              <h4>Accent Purple</h4>
              <p>#7C3AED</p>
              <span>创新、智慧、远见</span>
            </div>
          </div>
          <div class="color-card" data-aos="zoom-in" data-aos-delay="200">
            <div class="color-swatch" style="background: #10b981;"></div>
            <div class="color-info">
              <h4>Success Green</h4>
              <p>#10B981</p>
              <span>成长、可靠、可持续</span>
            </div>
          </div>
          <div class="color-card" data-aos="zoom-in" data-aos-delay="300">
            <div class="color-swatch" style="background: #0ea5e9;"></div>
            <div class="color-info">
              <h4>Sky Blue</h4>
              <p>#0EA5E9</p>
              <span>清晰、开放、全球化</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Typography -->
    <section class="typography-section">
      <div class="container">
        <h2 class="section-title">字体规范</h2>
        <div class="typography-grid">
          <div class="typography-card">
            <h3>主字体：Inter</h3>
            <div class="font-sample font-sample--bold">FULFILLDROP</div>
            <p>现代、简洁、高可读性</p>
            <code>font-family: 'Inter', -apple-system, sans-serif</code>
          </div>
          <div class="typography-card">
            <h3>备用字体</h3>
            <div class="font-sample">System UI Fonts</div>
            <p>Apple System, Segoe UI, Roboto</p>
            <code>-apple-system, BlinkMacSystemFont, 'Segoe UI'</code>
          </div>
        </div>
      </div>
    </section>

    <!-- Application Examples -->
    <section class="application-section">
      <div class="container">
        <h2 class="section-title">应用场景预览</h2>
        <div class="application-grid">
          <div class="app-card" data-aos="fade-up">
            <div class="app-preview app-preview--navbar">
              <svg viewBox="0 0 300 60" class="app-logo-svg">
                <rect x="10" y="18" width="16" height="11" rx="3" fill="#28b5c1"/>
                <text x="32" y="28" fill="#1e293b" font-family="Inter, sans-serif" font-size="14" font-weight="800">FULFILLDROP</text>
              </svg>
            </div>
            <p>导航栏应用</p>
          </div>
          <div class="app-card" data-aos="fade-up" data-aos-delay="100">
            <div class="app-preview app-preview--business">
              <svg viewBox="0 0 300 180" class="app-logo-svg-lg">
                <rect x="20" y="30" width="80" height="55" rx="12" fill="#28b5c1"/>
                <text x="60" y="95" fill="#fff" font-family="Inter, sans-serif" font-size="20" font-weight="800" text-anchor="middle">FULFILLDROP</text>
              </svg>
            </div>
            <p>名片应用</p>
          </div>
          <div class="app-card" data-aos="fade-up" data-aos-delay="200">
            <div class="app-preview app-preview--mobile">
              <svg viewBox="0 0 120 200" class="app-logo-svg-mobile">
                <rect x="10" y="10" width="100" height="100" rx="20" fill="#28b5c1"/>
                <rect x="35" y="40" width="24" height="16" rx="5" fill="#fff"/>
                <text x="60" y="140" fill="#1e293b" font-family="Inter, sans-serif" font-size="16" font-weight="700" text-anchor="middle">FULFILLDROP</text>
              </svg>
            </div>
            <p>移动应用图标</p>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA -->
    <section class="cta-section">
      <div class="container">
        <h2 class="cta-title">选择您最喜欢的设计方案</h2>
        <p class="cta-desc">每个方案都包含完整的品牌视觉识别系统</p>
        <button class="cta-button" @click="$router.push('/')">返回首页</button>
      </div>
    </section>
  </div>
</template>

<script>
import AOS from 'aos'

export default {
  name: 'LogoDesign',
  mounted() {
    // Initialize AOS
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true
    })
  }
}
</script>

<style scoped>
.logo-design-page {
  min-height: 100vh;
  background: #f8fafc;
}

/* Hero Section */
.logo-hero {
  background: linear-gradient(135deg, #28b5c1 0%, #1e9aa5 100%);
  padding: 100px 0;
  text-align: center;
}

.logo-hero-title {
  font-size: 3.5rem;
  font-weight: 800;
  color: #fff;
  margin-bottom: 1rem;
  letter-spacing: -0.02em;
}

.logo-hero-desc {
  font-size: 1.25rem;
  color: rgba(255, 255, 255, 0.9);
  max-width: 600px;
  margin: 0 auto;
}

/* Section Styles */
.section-title {
  font-size: 2.5rem;
  font-weight: 800;
  color: #1e293b;
  text-align: center;
  margin-bottom: 3rem;
  letter-spacing: -0.02em;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* Principles Section */
.principles-section {
  padding: 80px 0;
}

.principles-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.principle-card {
  background: #fff;
  padding: 2rem;
  border-radius: 16px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease;
}

.principle-card:hover {
  transform: translateY(-4px);
}

.principle-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #28b5c1, #1e9aa5);
  border-radius: 12px;
  color: #fff;
  font-size: 1.5rem;
}

.principle-card h3 {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 0.5rem;
}

.principle-card p {
  color: #64748b;
  line-height: 1.6;
}

/* Logo Options Section */
.logo-options-section {
  padding: 80px 0;
  background: #fff;
}

.logo-option {
  margin-bottom: 6rem;
}

.logo-option:last-child {
  margin-bottom: 0;
}

.logo-option-header {
  text-align: center;
  margin-bottom: 3rem;
}

.logo-option-header h3 {
  font-size: 2rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 0.5rem;
}

.logo-option-header p {
  color: #64748b;
  font-size: 1.1rem;
}

.logo-display {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
}

.logo-preview {
  background: #f8fafc;
  border-radius: 20px;
  padding: 3rem;
  width: 100%;
  max-width: 800px;
  display: flex;
  justify-content: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}

.logo-svg {
  width: 100%;
  height: auto;
}

.logo-variants {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
  width: 100%;
  max-width: 800px;
}

.variant-card {
  background: #f8fafc;
  border-radius: 12px;
  padding: 1.5rem;
  text-align: center;
}

.variant-label {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: #64748b;
  margin-bottom: 1rem;
}

.variant-preview {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}

.variant-preview--dark {
  background: #1e293b;
}

.variant-preview--mono,
.variant-preview--mono-2 {
  background: #f1f5f9;
}

.variant-preview--light {
  background: linear-gradient(135deg, #28b5c1, #1e9aa5);
}

.variant-preview--icon {
  background: #f8fafc;
}

.variant-preview--app {
  background: #f1f5f9;
}

.variant-preview--simple {
  background: #fff;
  border: 1px solid #e2e8f0;
}

.variant-preview--package {
  background: #f1f5f9;
}

.logo-svg-sm,
.logo-svg-icon {
  width: 100%;
  height: 100%;
  max-width: 150px;
}

/* Color Palette Section */
.color-palette-section {
  padding: 80px 0;
}

.color-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.color-card {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.color-swatch {
  height: 160px;
  width: 100%;
}

.color-info {
  padding: 1.5rem;
}

.color-info h4 {
  font-size: 1.125rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 0.25rem;
}

.color-info p {
  font-family: 'Courier New', monospace;
  color: #64748b;
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
}

.color-info span {
  display: block;
  font-size: 0.875rem;
  color: #94a3b8;
}

/* Typography Section */
.typography-section {
  padding: 80px 0;
  background: #fff;
}

.typography-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.typography-card {
  background: #f8fafc;
  padding: 2rem;
  border-radius: 16px;
}

.typography-card h3 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 1rem;
}

.font-sample {
  font-size: 3rem;
  color: #1e293b;
  margin-bottom: 1rem;
}

.font-sample--bold {
  font-weight: 800;
}

.typography-card p {
  color: #64748b;
  margin-bottom: 1rem;
}

.typography-card code {
  display: block;
  background: #1e293b;
  color: #e2e8f0;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  font-size: 0.875rem;
  font-family: 'Courier New', monospace;
}

/* Application Section */
.application-section {
  padding: 80px 0;
}

.application-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
}

.app-card {
  background: #fff;
  border-radius: 16px;
  padding: 2rem;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}

.app-preview {
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  border-radius: 12px;
  overflow: hidden;
}

.app-preview--navbar {
  background: #fff;
  border: 1px solid #e2e8f0;
}

.app-preview--business {
  background: #f8fafc;
}

.app-preview--mobile {
  background: #f1f5f9;
}

.app-logo-svg,
.app-logo-svg-lg,
.app-logo-svg-mobile {
  width: 100%;
  height: auto;
}

/* CTA Section */
.cta-section {
  background: linear-gradient(135deg, #28b5c1 0%, #1e9aa5 100%);
  padding: 80px 0;
  text-align: center;
}

.cta-title {
  font-size: 2.5rem;
  font-weight: 800;
  color: #fff;
  margin-bottom: 1rem;
}

.cta-desc {
  font-size: 1.125rem;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 2rem;
}

.cta-button {
  background: #fff;
  color: #28b5c1;
  border: none;
  padding: 1rem 3rem;
  font-size: 1.125rem;
  font-weight: 700;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);
}

/* Responsive */
@media (max-width: 768px) {
  .logo-hero-title {
    font-size: 2.5rem;
  }

  .section-title {
    font-size: 2rem;
  }

  .logo-option-header h3 {
    font-size: 1.5rem;
  }

  .logo-preview {
    padding: 2rem;
  }

  .color-grid,
  .principles-grid,
  .typography-grid,
  .application-grid {
    grid-template-columns: 1fr;
  }
}
</style>
